"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TooltipListener {
    constructor(container, map, markers) {
        this.container = container;
        this.map = map;
        this.markers = markers;
        this.popupOpened();
    }
    popupOpened() {
        const popup = this.container.querySelector('.leaflet-popup-pane');
        popup === null || popup === void 0 ? void 0 : popup.addEventListener('click', (e) => {
            const shouldOpenPost = e.target.getAttribute('data-js-osm-id');
            if (!shouldOpenPost)
                return;
            const post = this.container.querySelector(`#${shouldOpenPost}`);
            if (post) {
                post.click();
            }
        });
    }
}
exports.default = TooltipListener;
